import React from "react";
import ownerImg from "../../../assets/ownerImg.png";
import styles from "./Owner.module.scss";

const Owner = () => {
  return (
    <div className={styles.container}>
      <div className={styles.name}>
        <img src={ownerImg} alt="owner" />
        <h6>By Tyler Smith</h6>
      </div>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dictum et etiam
        ultricies mi eu iaculis arcu vel. Vel integer molestie bibendum massa
        vehicula in magna tempus cursus.
      </p>
    </div>
  );
};

export default Owner;
